import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import { BUTTON_COLORS, BUTTON_SIZES } from '../Button/classes';

const HeaderMegaMenuMenuButton = ({
  color,
  className,
  children,
  href,
  icon,
  onClick,
  targetBlank,
  size,
  ...rest
}) => <Button
    className={className}
    color={color}
    href={href}
    icon={icon}
    onClick={onClick}
    size={size}
    {...(targetBlank ? { target: '_blank' } : {})}
    {...rest}
  >
    <span className="c-header-nav__text">{children}</span>
  </Button>

export default HeaderMegaMenuMenuButton;

HeaderMegaMenuMenuButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(BUTTON_COLORS),
  href: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(BUTTON_SIZES),
  targetBlank: PropTypes.bool,
};

HeaderMegaMenuMenuButton.defaultProps = {
  className: null,
  color: 'null',
  href: '',
  icon: '',
  onClick: () => {},
  size: null,
  targetBlank: false,
};
